// src/api.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

export const loginUser = (email, password) =>
  api.post("/login", { email, password });

export const logoutUser = () => api.get("/logout");

export const refreshSession = () => api.post("/auth/refresh-session");

export const getUserInfo = () =>
  api.get("/account/get_info").then((res) => res.data);

export const registerUser = (data) => api.post("/register", data);

export const validateReferralCode = (code) =>
  api.post("/referral/validate", { code }).then((res) => res.data);
